import type { FC, PropsWithChildren } from "react";

import Alert, { type AlertProps } from "@mui/material/Alert";
import Box from "@mui/material/Box";

import useMediaQuery from "@hooks/useMediaQuery";
import darkTheme from "@styles/theme/colors";

export interface AlertBoxProps extends AlertProps {
	borderBoxColor?: string;
}

const AlertBox: FC<PropsWithChildren<AlertBoxProps>> = ({
	action,
	borderBoxColor = darkTheme.Color.Rainbow,
	children,
	...props
}) => {
	const { isMobile } = useMediaQuery();

	return (
		<Box
			sx={{
				background: borderBoxColor,
				borderRadius: 2,
				px: 0.25,
				py: 0.25,
			}}
		>
			<Alert
				sx={{
					// borderBottomRightRadius: action ? 0 : "inherit",
					backgroundColor: darkTheme.Color.BackgroundOne,
					// borderBottomLeftRadius: action ? 0 : "inherit",
					border: "unset",
					borderRadius: 2,
					...props?.sx,
				}}
				variant="outlined"
				severity="warning"
				action={isMobile ? null : action}
				{...props}
			>
				{children}
			</Alert>
			{action && isMobile ? (
				<Box
					sx={{
						backgroundColor:
							// @ts-expect-error: TODO
							props?.sx?.backgroundColor ?? darkTheme.Color.BackgroundOne,
						borderRadius: 2,
						borderTopLeftRadius: 2,
						borderTopRightRadius: 2,
					}}
					display="flex"
					justifyContent="center"
					alignItems="center"
					paddingX={2}
					paddingY={2}
				>
					{isMobile ? action : null}
				</Box>
			) : null}
		</Box>
	);
};

export default AlertBox;
